import React from "react";
import Sparkline from "./Sparkline";

export default function MetricTile({ label, value, unit, trend, color = "#0A0A0A", testId }) {
  return (
    <div className="panel p-6 flex flex-col gap-4 hover:-translate-y-0.5 transition-transform" data-testid={testId}>
      <div className="flex items-center justify-between">
        <div className="eyebrow">{label}</div>
        {trend && trend.length > 1 && <Sparkline values={trend} color={color} width={72} height={26} />}
      </div>
      <div>
        <div className="font-display text-5xl leading-none">
          {value ?? "—"}
          {unit && <span className="text-xl ml-1 text-neutral-500">{unit}</span>}
        </div>
      </div>
    </div>
  );
}
